import { gql } from "@apollo/client";

export const GET_USER_DETAIL = gql`
    query GetUserDetails($customerid: uuid, $userid: uuid) {
        user: ums_users(where: { customerid: { _eq: $customerid }, id: { _eq: $userid } }) {
            id
            customerid
            email
            emailverified
            name1
            name2
            deleted
            customer {
                name
            }
            registered
            registereddate
            registrationcode
            activated
            system
            erpcloud
            erpid
            userroles(distinct_on: role) {
                role
            }
            invitationid
            state
        }
    }
`;

export const GET_USER_AUDITS = gql`
    query GetUserAudits($userid: uuid!, $customerid: uuid!, $limit: Int = 50) {
        audits: ums_audits(
            where: { userid: { _eq: $userid }, _and: { customerid: { _eq: $customerid } } }
            order_by: { timestamp: desc }
            limit: $limit
        ) {
            event
            reason
            timestamp
            ids4_client {
                clientname: ClientName
            }
        }
    }
`;

export const GET_USER_REALESTATE_ACCESS = gql`
    query GetUserRealestateAccess($customerid: uuid!, $userid: uuid!) {
        access: common_v_access_users_realestates(
            where: { customerid: { _eq: $customerid }, userid: { _eq: $userid } }
            order_by: { realestatename: asc }
        ) {
            realestateid
            realestatename
            realestatenumber
            role
            condominium
            consolidation
            consolidationid
            deleted
        }
        role_enumerations: common_enumerations(
            where: { type: { _eq: 91 }, language: { _eq: "de" } }
            order_by: { key: asc }
        ) {
            key
            label
        }
    }
`;

export const GET_USER_TENANT_ACCESS = gql`
    query GetUserTenantAccess($customerid: uuid!, $userid: uuid!) {
        tenant_access: common_v_access_users_tenants(
            where: { customerid: { _eq: $customerid }, userid: { _eq: $userid } }
            order_by: [{ realestatename: asc }, { unitname: asc }, { tenantname: asc }]
        ) {
            tenantid
            tenancyid
            role
            accesslevel
            realestateid
            realestatename
            realestatenumber
            unitid
            unitname
            unitnumber
            leasestart
            leaseend
            tenantname
        }
    }
`;
